import { useState } from "react";

import common from "~/i18n/common";
import quotes from "~/i18n/quotes";
import { useT } from "~/i18n/useT";

import "./Testimonial.scss";

export default function Testimonial() {
  const t = useT(quotes);
  const c = useT(common);
  const [index, setIndex] = useState(0);

  const total = t.items.length;
  const quote = t.items[index];

  const step = (delta: number) => setIndex((i) => (i + delta + total) % total);

  return (
    <section className="ss-section ss-container">
      <figure className="ss-quote">
        <div className="ss-quote__portrait">
          <img
            src={quote.image}
            alt=""
            width={150}
            height={150}
            loading="lazy"
            decoding="async"
          />
          <span className="ss-quote__mark" aria-hidden="true">
            &ldquo;
          </span>
        </div>

        <div className="ss-quote__body">
          {/* aria-live so a screen reader hears the new quote after Next. */}
          <blockquote className="ss-quote__text" aria-live="polite">
            {quote.text}
          </blockquote>

          <figcaption className="ss-quote__foot">
            <div>
              <div className="ss-quote__name">{quote.name}</div>
              <div className="ss-quote__role">{quote.role}</div>
            </div>

            <div className="ss-quote__nav">
              <button
                type="button"
                className="ss-quote__arrow"
                onClick={() => step(-1)}
                aria-label={c.a11y.previous}
              >
                <span className="ss-flip" aria-hidden="true">
                  ←
                </span>
              </button>
              <button
                type="button"
                className="ss-quote__arrow ss-quote__arrow--solid"
                onClick={() => step(1)}
                aria-label={c.a11y.next}
              >
                <span className="ss-flip" aria-hidden="true">
                  →
                </span>
              </button>
            </div>
          </figcaption>
        </div>
      </figure>
    </section>
  );
}
